
import Stack from '@mui/material/Stack';
import Divider from '@mui/material/Divider';
import EventListRow from './EventListRow';


export interface EventListDataProps {
    data: EventListData[];
}

export interface EventListData {
    photo: string[];
    mathConfidence: number;
    cameraStation: string;
    eventLocation: string;
    tags: string;
    eventDateTime: Date;
}

export default function EventsListTable(props: EventListDataProps) {

    return (
        <Stack spacing={4}
            sx={{
                pl: 2,
                pr: 2,
                pb: 3,
                pt: 1
            }}
            divider={<Divider orientation="horizontal" flexItem={true} />}
        >

            {props.data.map((listDataRow, i) => {

            return <EventListRow key={i} data={listDataRow} />
            })}

            
        </Stack>

    )

}
